import Code39Image from '@/assets/barcode/code39_image.png';
import Code128Image from '@/assets/barcode/code128_image.png';
import EAN8Image from '@/assets/barcode/ean8_image.png';
import EAN13Image from '@/assets/barcode/ean13_image.png';
import ITF25Image from '@/assets/barcode/itf25_image.png';
import UPCAImage from '@/assets/barcode/upca_image.png';
import QRCodeImage from '@/assets/barcode/qrcode_image.png';
import DataMatrixImage from '@/assets/barcode/datamatrix_image.png';

import IconHorizontalAlignmentLeft from '@/icons/icon-horizontal-alignment-left.svg';
import IconHorizontalAlignmentLeftSelected from '@/icons/icon-horizontal-alignment-left-selected.svg';
import IconHorizontalAlignmentCenter from '@/icons/icon-horizontal-alignment-center.svg';
import IconHorizontalAlignmentCenterSelected from '@/icons/icon-horizontal-alignment-center-selected.svg';
import IconHorizontalAlignmentRight from '@/icons/icon-horizontal-alignment-right.svg';
import IconHorizontalAlignmentRightSelected from '@/icons/icon-horizontal-alignment-right-selected.svg';

import IconVerticalAlignmentTop from '@/icons/icon-vertical-alignment-top.svg';
import IconVerticalAlignmentTopSelected from '@/icons/icon-vertical-alignment-top-selected.svg';
import IconVerticalAlignmentMiddle from '@/icons/icon-vertical-alignment-middle.svg';
import IconVerticalAlignmentMiddleSelected from '@/icons/icon-vertical-alignment-middle-selected.svg';
import IconVerticalAlignmentBottom from '@/icons/icon-vertical-alignment-bottom.svg';
import IconVerticalAlignmentBottomSelected from '@/icons/icon-vertical-alignment-bottom-selected.svg';

import IconBarcodeVerticalAlignmentTop from '@/icons/icon-barcode-vertical-alignment-top.svg';
import IconBarcodeVerticalAlignmentTopSelected from '@/icons/icon-barcode-vertical-alignment-top-selected.svg';
import IconBarcodeVerticalAlignmentBottom from '@/icons/icon-barcode-vertical-alignment-bottom.svg';
import IconBarcodeVerticalAlignmentBottomSelected from '@/icons/icon-barcode-vertical-alignment-bottom-selected.svg';

import IconIncludeText from '../components/Icon/CmmeIcons/IconIncludeText';

const commonOptions = {
  barratio: {
    labelId: 'app.editor.sideMenu.panelLabel.ratio',
    displayName: 'Ratio',
    values: [
      {
        label: '2',
        value: 2,
      },
      {
        label: '2.5',
        value: 2.5,
      },
      {
        label: '3',
        value: 3,
      },
    ],
    defaultValueIndex: 0,
    inputType: 'tabs'
  },
  includetext: {
    labelId: 'app.editor.sideMenu.panelLabel.includeText',
    displayName: 'Include text',
    values: [
      {
        value: false,
        Icon: IconIncludeText,
      },
    ],
    defaultValueIndex: 0,
    inputType: 'checkbox'
  },
  includecheck: {
    labelId: 'app.editor.sideMenu.panelLabel.includeCheck',
    displayName: 'Include check digit in barcode',
    values: [
      {
        value: true,
        label: 'Yes',
        labelId: 'app.editor.sideMenu.panelLabel.option.yes',
      },
      {
        value: false,
        label: 'No',
        labelId: 'app.editor.sideMenu.panelLabel.option.no',
      },
    ],
    defaultValueIndex: 1,
    inputType: 'checkbox',
  },
  includecheckintext: {
    labelId: 'app.editor.sideMenu.panelLabel.includeCheckInText',
    displayName: 'Include check digit in text',
    values: [
      {
        value: true,
        label: 'Yes',
        labelId: 'app.editor.sideMenu.panelLabel.option.yes',
      },
      {
        value: false,
        label: 'No',
        labelId: 'app.editor.sideMenu.panelLabel.option.no',
      },
    ],
    defaultValueIndex: 0,
    inputType: 'checkbox',
  },
  textxalign: {
    labelId: 'app.editor.sideMenu.panelLabel.textXAlign',
    displayName: 'Horizontal text align',
    values: [
      {
        value: 'left',
        Icon: IconHorizontalAlignmentLeft,
        IconSelected: IconHorizontalAlignmentLeftSelected,
      },
      {
        value: 'center',
        Icon: IconHorizontalAlignmentCenter,
        IconSelected: IconHorizontalAlignmentCenterSelected,
      },
      {
        value: 'right',
        Icon: IconHorizontalAlignmentRight,
        IconSelected: IconHorizontalAlignmentRightSelected,
      },
    ],
    defaultValueIndex: 1,
    inputType: 'tabs',
  },
  textyalign: {
    labelId: 'app.editor.sideMenu.panelLabel.textYAlign',
    displayName: 'Vertical text align',
    values: [
      {
        value: 'above',
        Icon: IconBarcodeVerticalAlignmentTop,
        IconSelected: IconBarcodeVerticalAlignmentTopSelected
      },
      /*
      {
        value: 'center',
        Icon: IconVerticalAlignmentMiddle,
        IconSelected: IconVerticalAlignmentMiddle,
      },
      */
      {
        value: 'below',
        Icon: IconBarcodeVerticalAlignmentBottom,
        IconSelected: IconBarcodeVerticalAlignmentBottomSelected,
      }
    ],
    defaultValueIndex: 1,
    inputType: 'tabs',
  },
  guardwhitespace: {
    labelId: 'app.editor.sideMenu.panelLabel.guardWhitespace',
    displayName: 'Guard whitespace',
    values: [
      {
        value: true,
        label: 'Yes',
        labelId: 'app.editor.sideMenu.panelLabel.option.yes',
      },
      {
        value: false,
        label: 'No',
        labelId: 'app.editor.sideMenu.panelLabel.option.no',
      },
    ],
    defaultValueIndex: 1,
    inputType: 'checkbox',
  },
};

export const linearCodes = [
  {
    label: { id: 'app.editor.sideMenu.panelLabel.code39', defaultMessage: 'Code 39' },
    value: 'code39',
    imgSrc: Code39Image,
    regex: /^[0-9A-Z\-.$/\+%\*\s]*$/,
    example: { id: 'app.editor.sideMenu.panelLabel.code39.examplePlaceholder', defaultMessage: 'THIS IS CODE 39' },
    options: {
      basic: {
        includetext: commonOptions.includetext,
        textxalign: commonOptions.textxalign,
        textyalign: commonOptions.textyalign,
        includecheck: commonOptions.includecheck,
      },
      advanced: {
        barratio: commonOptions.barratio,
        includecheckintext: commonOptions.includecheckintext,
        hidestars: {
          labelId: 'app.editor.sideMenu.panelLabel.hideStars',
          displayName: 'Hide stars',
          values: [
            {
              value: true,
              label: 'Yes',
              labelId: 'app.editor.sideMenu.panelLabel.option.yes',
            },
            {
              value: false,
              label: 'No',
              labelId: 'app.editor.sideMenu.panelLabel.option.no',
            },
          ],
          defaultValueIndex: 1,
          inputType: 'checkbox'
        },
      },
    },
  },
  {
    label: { id: 'app.editor.sideMenu.panelLabel.code128', defaultMessage: 'Code 128' },
    value: 'code128',
    imgSrc: Code128Image,
    regex: /^[\000-\177]*$/,
    example: { id: 'app.editor.sideMenu.panelLabel.code128.examplePlaceholder', defaultMessage: 'Count01234567!' },
    options: {
      basic: {
        includetext: commonOptions.includetext,
        textxalign: commonOptions.textxalign,
        textyalign: commonOptions.textyalign,
      },
      advanced: {},
    },
  },
  {
    label: { id: 'app.editor.sideMenu.panelLabel.itf25', defaultMessage: 'ITF 2/5' },
    value: 'interleaved2of5',
    imgSrc: ITF25Image,
    regex: /^\d{1,}$/,
    example: { id: 'app.editor.sideMenu.panelLabel.itf25.examplePlaceholder', defaultMessage: '2401234567' },
    options: {
      basic: {
        includetext: commonOptions.includetext,
        textxalign: commonOptions.textxalign,
        textyalign: commonOptions.textyalign,
        includecheck: commonOptions.includecheck,
      },
      advanced: {
        barratio: commonOptions.barratio,
        includecheckintext: commonOptions.includecheckintext,
      },
    },
  },
  {
    label: { id: 'app.editor.sideMenu.panelLabel.ean8', defaultMessage: 'EAN-8' },
    value: 'ean8',
    imgSrc: EAN8Image,
    regex: /^\d{7,8}$/,
    example: { id: 'app.editor.sideMenu.panelLabel.ean8.examplePlaceholder', defaultMessage: '02345673' },
    options: {
      basic: {
        includetext: commonOptions.includetext,
      },
      advanced: {
        guardwhitespace: commonOptions.guardwhitespace,
      },
    },
  },
  {
    label: { id: 'app.editor.sideMenu.panelLabel.ean13', defaultMessage: 'EAN-13' },
    value: 'ean13',
    imgSrc: EAN13Image,
    regex: /^\d{12,13}$/,
    example: { id: 'app.editor.sideMenu.panelLabel.ean13.examplePlaceholder', defaultMessage: '2112345678900' },
    options: {
      basic: {
        includetext: commonOptions.includetext,
      },
      advanced: {
        guardwhitespace: commonOptions.guardwhitespace,
      },
    },
  },
  {
    label: { id: 'app.editor.sideMenu.panelLabel.upca', defaultMessage: 'UPC-A' },
    value: 'upca',
    imgSrc: UPCAImage,
    regex: /^\d{11,12}$/,
    example: { id: 'app.editor.sideMenu.panelLabel.upca.examplePlaceholder', defaultMessage: '416000336108' },
    options: {
      basic: {
        includetext: commonOptions.includetext,
      },
      advanced: {
        guardwhitespace: commonOptions.guardwhitespace,
      },
    },
  },
  {
    label: { id: 'app.editor.sideMenu.panelLabel.upce', defaultMessage: 'UPC-E' },
    value: 'upce',
    imgSrc: UPCAImage,
    regex: /^\d{11,12}$/,
    example: { id: 'app.editor.sideMenu.panelLabel.upce.examplePlaceholder', defaultMessage: '00123457' },
    options: {
      basic: {
        includetext: commonOptions.includetext,
      },
      advanced: {
        guardwhitespace: commonOptions.guardwhitespace,
      },
    },
  },
];

export const twoDCodes = [
  {
    label: { id: 'app.editor.sideMenu.panelLabel.qrCode', defaultMessage: 'QR Code' },
    value: 'qrcode',
    imgSrc: QRCodeImage,
    regex: /.*/,
    example: { id: 'app.editor.sideMenu.panelLabel.qrCode.examplePlaceholder', defaultMessage: 'http://some.url/page' },
    options: {
      basic: {
        eclevel: {
          labelId: 'app.editor.sideMenu.panelLabel.ecLevel',
          displayName: 'ECC level',
          values: [
            {
              labelId: 'app.editor.sideMenu.panelLabel.eccLevelOptions.low',
              label: 'Low',
              value: 'L',
            },
            {
              labelId: 'app.editor.sideMenu.panelLabel.eccLevelOptions.medium',
              label: 'Medium',
              value: 'M',
            },
            {
              labelId:
                'app.editor.sideMenu.panelLabel.eccLevelOptions.quartile',
              label: 'Quartile',
              value: 'Q',
            },
            {
              labelId: 'app.editor.sideMenu.panelLabel.eccLevelOptions.high',
              label: 'High',
              value: 'H',
            },
          ],
          defaultValueIndex: 1,
          inputType: 'tabs',
        },
        textxalign: {
          labelId: 'app.editor.menu.format.horAlignment',
          displayName: 'Horizontal align',
          values: [
            {
              value: 'left',
              Icon: IconHorizontalAlignmentLeft,
              IconSelected: IconHorizontalAlignmentLeftSelected,
            },
            {
              value: 'center',
              Icon: IconHorizontalAlignmentCenter,
              IconSelected: IconHorizontalAlignmentCenterSelected,
            },
            {
              value: 'right',
              Icon: IconHorizontalAlignmentRight,
              IconSelected: IconHorizontalAlignmentRightSelected,
            },
          ],
          defaultValueIndex: 1,
          inputType: 'tabs',
        },
        textyalign: {
          labelId: 'app.editor.menu.format.vertAlignment',
          displayName: 'Vertical align',
          values: [
            {
              value: 'above',
              Icon: IconVerticalAlignmentTop,
              IconSelected: IconVerticalAlignmentTopSelected
            },
            {
              value: 'center',
              Icon: IconVerticalAlignmentMiddle,
              IconSelected: IconVerticalAlignmentMiddleSelected,
            },
            {
              value: 'below',
              Icon: IconVerticalAlignmentBottom,
              IconSelected: IconVerticalAlignmentBottomSelected,
            }
          ],
          defaultValueIndex: 1,
          inputType: 'tabs',
        }
      },
      advanced: {},
    },
  },
  {
    label: { id: 'app.editor.sideMenu.panelLabel.dataMatrix', defaultMessage: 'Data Matrix' },
    value: 'datamatrix',
    imgSrc: DataMatrixImage,
    regex: /^[\x00-\xff]*$/,
    example: { id: 'app.editor.sideMenu.panelLabel.dataMatrix.examplePlaceholder', defaultMessage: 'This is Data Matrix!' },
    options: {
      basic: {},
      advanced: {},
    },
  },
];